import axios from 'axios';
import config from 'config/config.public.js';

function generateSignature(callback, params_to_sign) {
  axios({
    method: 'post',
    url: '/api/utility/getCloudinarySignature',
    params: {},
    data: {
      ...params_to_sign,
    },
  })
    .then((result) => {
      callback(result.data.signature);
    })
    .catch((result) => {});
}

let cloudinaryWidget = null;
// The options the cached widget was built with. Cloudinary bakes its options in
// at createUploadWidget time and offers no way to change them afterwards, so a
// widget built for one caller cannot be handed to a caller that wants different
// ones. Without this, whoever opened the widget FIRST in a session would decide
// whether every later upload was cropped.
let cloudinaryWidgetKey = null;

/**
 * Open the Cloudinary upload widget.
 *
 * `cropping` DEFAULTS TO THE SQUARE CROP THIS ALWAYS DID. Seven of the eight
 * callers are avatars, point images and blog art, and every one of them has
 * been getting a forced 1:1 crop since this was written; changing that
 * wholesale would silently alter what they produce. Only a caller that asks
 * opts out.
 *
 * FAQ answers are the caller that asks. A screenshot squared is unreadable,
 * which is the entire reason this parameter exists.
 *
 * @param {function} afterImageAdded  receives the uploaded secure_url
 * @param {boolean}  [cropping=true]  false uploads at the image's own aspect
 * @param {string}   [folder]         Cloudinary folder, defaults as before
 */
export function openUploadWidget({
  afterImageAdded,
  cropping = true,
  folder = 'source-subscription',
}) {
  const cloudinaryOptions = {
    cloudName: config.cloudinary.cloud_name,
    uploadPreset: 'yxidy7xn',
    apiKey: config.cloudinary.api_key,
    // Cloudinary reads these as strings, which is why the original wrote
    // 'true' rather than true.
    cropping: cropping ? 'true' : 'false',
    ...(cropping ? { cropping_aspect_ratio: 1 } : {}),
    resource_type: 'image',
    uploadSignature: generateSignature,
    publicId: null,
    invalidate: true,
    sources: ['local', 'url', 'image_search'],
    folder,
  };

  const key = `${cloudinaryOptions.cropping}:${folder}`;

  // Rebuild rather than reuse when the caller wants something different from
  // whatever the cached widget was built for.
  if (cloudinaryWidget && cloudinaryWidgetKey !== key) {
    try {
      cloudinaryWidget.destroy();
    } catch (e) {
      // An already-torn-down widget is not a problem worth surfacing; the
      // reference is dropped either way.
    }
    cloudinaryWidget = null;
  }

  if (!cloudinaryWidget) {
    cloudinaryWidgetKey = key;
    cloudinaryWidget = window.cloudinary.createUploadWidget(
      cloudinaryOptions,
      (error, result) => {
        if (error) {
          return;
        }

        if (result.event == 'success') {
          afterImageAdded(result.info.secure_url);
          cloudinaryWidget.close();
        }
      },
    );
    cloudinaryWidget.open();
  } else {
    if (!cloudinaryWidget.isShowing()) {
      cloudinaryWidget.open();
    }
  }
}
